import { useEffect } from "react";
import { selectAuthUser } from "../../../auth/redux/authSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { resumeExport } from "../redux/ticketExport/thunk";

export function TicketExportResumer(): null {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(selectAuthUser)?.id;

  useEffect(() => {
    if (userId == null) return;
    dispatch(resumeExport("list"));
    dispatch(resumeExport("progressReport"));
    dispatch(resumeExport("missionList"));
  }, [dispatch, userId]);

  return null;
}
